import React from "react"

const Prose = ({ children }) => (
  <article className="prose prose-gray prose-lg max-w-none prose-natural prose-headings:font-semibold dark:prose-invert dark:prose-hr:border-stone-600 dark:prose-tr:border-stone-600">
    {children}
  </article>
)

export default Prose
